import useBudgetingService from 'domain/organization/serviceCatalog/budgets/budgetingService';
import React from 'react';
import { UpdateForm } from 'framework/form';
import { UpdateTimelineItemLayout } from 'framework/ui/timeline';
import ServiceCostsStructureForm from 'domain/organization/serviceCatalog/budgets/structure/Create/ServiceCostsStructureForm';
import { cloneDeep } from 'lodash';

const UpdateServiceBudgetStructure = ({ getDataFunc, entityId, onCancel, afterSubmit }: any) => {
  const { updateStructure, getValidationSchema } = useBudgetingService();

  const getData = () => {
    const data = cloneDeep(getDataFunc());
    data.categories = data.categories.map((name: string) => ({ name }));
    return data;
  };

  return (
    <UpdateForm
      submitFormFunc={async (_id, values) => updateStructure(entityId, values)}
      afterSubmit={afterSubmit}
      getValidationSchemaFunc={getValidationSchema}
      getDataFunc={getData}
    >
      <UpdateTimelineItemLayout onCancel={onCancel}>
        <ServiceCostsStructureForm />
      </UpdateTimelineItemLayout>
    </UpdateForm>
  );
};

export default UpdateServiceBudgetStructure;
